<template>
  <div v-if="isExplorer" class="browser-check">
    <div class="browser-check__body d-flex flex-column flex-center">
      <p class="browser-check__body--title">Ci dispiace, ma il browser Explorer che stai utilizzando non permette di visualizzare il simulatore di GeneraSviluppo Sostenibile.</p>
      <p class="browser-check__body--subtitle">I browser supportati sono</p>
      <div class="browser-check__body--browser-list d-inline-flex justify-center">
        <div
          class="browser-check__body--browser-list-item d-flex flex-column align-items-center"
          v-for="(browser, index) in browsers"
          :key="index"
        >
          <img :src="require(`../assets/images/browser-icons/${browser.icon}`)" />
          <p>{{ browser.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrowserCheck",
  data() {
    return {
      browsers: [
        { name: "Microsoft Edge", icon: "microsoft-edge.svg" },
        { name: "Chrome", icon: "google-chrome.svg" },
        { name: "Safari", icon: "safari.svg" },
        { name: "Opera", icon: "opera.svg" }
      ]
    };
  },
  computed: {
    isExplorer() {
      let userAgent = window.navigator.userAgent;
      return /MSIE|Trident/.test(userAgent);
    }
  }
};
</script>

<style lang="scss" scoped>
.browser-check {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-color: #ffffff;

  &__body {
    margin: 0 auto;
    width: 100%;
    max-width: 620pt;
    height: 100%;

    font-family: "Roboto", sans-serif;
    font-weight: 400;
    text-align: center;
    color: #393939;

    & > * {
      width: 100%;
    }

    &--title {
      font-size: 28pt;
      letter-spacing: 0.4pt;
    }

    &--subtitle {
      font-size: 14pt;

      margin-top: 50pt;
    }

    &--browser-list {
      margin-top: 30pt;

      &-item {
        margin: 0 32pt;

        font-size: 10pt;

        & > img {
          height: 42pt;
          max-width: 100%;
          width: auto;
        }

        & > p {
          margin-top: 10pt;
        }
      }
    }
  }
}
</style>
